import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    delay: Number
  }

  connect() {
    if (!this.hasUrlValue || !this.urlValue) return

    const delayMs = (this.delayValue || 0) * 1000

    this.timeoutId = window.setTimeout(() => {
      // Use assign to preserve history so users can navigate back if needed
      window.location.assign(this.urlValue)
    }, delayMs)
  }

  disconnect() {
    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId)
    }
  }
}
